import { render, staticRenderFns } from "./FormularioMobilidadeComponent.vue?vue&type=template&id=63ffede0"
import script from "./FormularioMobilidadeComponent.vue?vue&type=script&lang=js"
export * from "./FormularioMobilidadeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports